import type { IconSvgObject } from './types';

const City03Icon: IconSvgObject = [
  ["path", { d: "M17 12.0003V4C17 2.89543 16.1046 2 15 2L9.99999 2.00002C8.89543 2.00003 8 2.89546 8 4.00002V22.0001", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 16C4.32843 16 5 15.1046 5 14C5 12.8954 4.32843 12 3.5 12C2.67157 12 2 12.8954 2 14C2 15.1046 2.67157 16 3.5 16Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.49609 16V22", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 22H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M11.5 6H13.5M11.5 9H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M17 22V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }],
  ["path", { d: "M13 22V15.0087L17 12L21 15.0087V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "6" }]
];

export default City03Icon;
